<script>
    import Mobilebtn from './mobilebtn.svelte';
    import MobileNavbar from '../reusableitems/mobileNavbar.svelte';
</script>
<div class="navbar">
    <MobileNavbar />
</div>
<div class="main">
    <div class="advert">
        <heading class="sub">A new paradigm for advertising</heading>
        <heading class="h1">
            Imagine dynamic placement of <span>3D+</span> never seen before.
        </heading>
        <div class="para">
            We're taking it to the next level by dynamically placing
            accessories, props and apparel of beloved characters. Coupling it
            with anonymous privacy respecting personalized product placement and
            the ad world will never be the same again.
        </div>
        <div class="green">
            <img id="green" src="images/advertMobile/greengirl.svg" alt="" />
        </div>
        <div class="para2">
            That future is being build and you can be part of it by joining our
            advertiser governing council which grants you access to alpha
            testing, feature suggestions and one-to-one conversation with our
            team.
        </div>
        <div class="joinbtn">
            <Mobilebtn
            height="9.346vw"
            width= "65.421vw"
            text="Join Advertisement"
            text2="Governace Council"
            txtsize="2.804vw"
            txtsize2="2.804vw"
            bgcolor="#D578FF"
            lineheight = "6vw"
            state="Advertiser"/>
         </div>
    </div>
</div>

<style>
    
     .navbar{
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 4;
    }
    .main{
        position: relative;
        overflow: hidden;
        height: max(216.355vw, 100vh);
    }
    .joinbtn {
        position: absolute;
        left: 18vw;
        top: 201.028vw;
    }
    .green {
        position: absolute;
        width: 102vw;
        height: 136vw;
        top: 66vw;
    }
    #green {
        width: 100%;
        height: 100%;
    }
    .advert {
        height: max(216.355vw, 100vh);
        background: #f4eeec;
        font-family: "Orbitron";
    }
    .sub {
        position: absolute;
        top: 38.15vw;
        left: 8.5vw;
        font-size: 2.336vw;
        font-weight: 400;
        line-height: 6.336vw;
        text-align: left;
        border-bottom: solid 0.047vw black;
    }

    .h1 {
        position: absolute;
        top: 49.159vw;
        left: 8.178vw;
        font-size: 4.673vw;
        font-weight: 400;
        line-height: 5.374vw;
        letter-spacing: 0.06em;
        text-align: left;
    }

    .h1 span {
        font-weight: 800;
    }
    .para,
    .para2 {
        position: absolute;
        font-size: 2.804vw;
        font-weight: 700;
        line-height: 3.972vw;
        letter-spacing: 0.06em;
    }
    .para {
        width: 81.542vw;
        height: 23.832vw;
        top: 67.617vw;
        left: 8.178vw;
    }
    .para2 {
        width: 76.869vw;
    left: 11.682vw;
    top: 174.393vw;
    font-weight: 400;
    color: black;
    text-align: center;
    }
</style>
